import styled from "styled-components";

export const BodyContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 24px 82px 0 80px;

  @media only screen and (max-width: 768px) {
    padding: 12px 45px 0 30px;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 68px;
`;

export const TitleContent = styled.div`
  display: flex;
  margin-bottom: 32px;

  @media screen and (max-width: 670px) {
    flex-direction: column;
  }
`;

export const AttributeContainer = styled.div`
  position: relative;
  width: 100%;
  margin-left: 32px;

  @media screen and (max-width: 670px) {
    margin-left: 0;
  }
`;

export const SocialNetworkContainer = styled.div`
  display: flex;
  flex-direction: column;

  &::-webkit-scrollbar-thumb {
    background: #f4f7ff;
    width: 4px;
    -webkit-border-radius: 10px;
  }
  &::-webkit-scrollbar {
    width: 15px;
    background: #fcfcfc;
    width: 8px;
    -webkit-border-radius: 10px;
  }
`;
